import React, { Component } from "react";
import { Container, Row, Col, Table } from "reactstrap";
import { CSVLink } from "react-csv";
import ReactTable from "react-table";
import moment from "moment";
import "react-dates/initialize";
import { SingleDatePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import { Button, Form, Input, Alert, FormGroup, Label } from "reactstrap";
import { base_URL } from "../config/buildSettings.js";
import { apiKey } from "../config/index.js";
import { BounceLoader } from "react-spinners";
import { css } from "@emotion/core";

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

const options = {
  year: "numeric",
  month: "long",
  day: "numeric",
};


class DateRangeReports extends Component {
  constructor(props) {
    super(props);

    this.fetchData = this.fetchData.bind(this);
    this.toggleMessageAlert = this.toggleMessageAlert.bind(this);
    this.toggleErrorAlert = this.toggleErrorAlert.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleCalculate = this.handleCalculate.bind(this);

    this.state = {
      data: {},
      begin_date: moment("2017-01-01"),
      end_date: moment(),
      begin_dateFocused: false,
      end_dateFocused: false,
      loading: false,
      report: "",
      error: "",
      message: "",
      showMessageAlert: false,
      showErrorAlert: false,
      isTest: false,
      isInternal: false
    };
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.report !== this.props.match.params.report) {
      this.setState({
      data: {},
      begin_date: moment("2017-01-01"),
      end_date: moment(),
      begin_dateFocused: false,
      end_dateFocused: false,
      loading: false,
      report: "",
      error: "",
      message: "",
      showMessageAlert: false,
      showErrorAlert: false,
      isTest: false,
      isInternal: false
      });
    }
  }

  handleSelect(School_ID) {
    // if (this.props.match.params.report === "1") {
    //   this.props.history.push({ pathname: "/testschool/" + School_ID });
    // } else {
    this.props.history.push({ pathname: "/internalschool/" + School_ID });
    // }
  }

  toggleErrorAlert() {
    this.setState({
      showErrorAlert: !this.state.showErrorAlert,
      error: ""
    });
  }

  toggleMessageAlert() {
    this.setState({
      showMessageAlert: !this.state.showMessageAlert,
      message: ""
    });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }
  


  fetchData(event) {
    this.setState({ loading: true });
    let url, useCredentials;

    url = `${base_URL}/api/internal/daterangereports`;
    useCredentials = "include";

    const report = this.props.match.params.report;

    // console.log(url);
    fetch(url, {
      method: "POST",
      credentials: useCredentials,
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        apiKey: apiKey,
        report: report,
        begin_date: this.state.begin_date,
        end_date: this.state.end_date,
      }),
    })
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then(response => response.json())
      .then(json => {
        if (!json || json.length === 0) {
          let message;
          message = "No Data Found";
          this.setState({
            message: message,
            showMessageAlert: true,
            data: {},
            loading: false
          });

          return;
        }
        var old = JSON.stringify(json).replaceAll('T00:00:00', ''); //convert to JSON string
        var newArray = JSON.parse(old); //convert back to array

        this.setState({ data: newArray, loading: false });
      })
      .catch(error => {
        this.setState({
          error: error.message,
          showErrorAlert: true,
          data: {},
          loading: false
        });
      });
  }
  
  handleCalculate(event) {
    event.preventDefault();

    this.fetchData();
  }

  getColumns() {
    return Object.keys(this.state.data[0]).map(key => {
      return {
        Header: key,
        accessor: key
      };
    });
  }

  getTitle() {
    switch (this.props.match.params.report) {
      case "1":
        return <span className="h4">Schools and Providers with Initial Samples within Date Range ({" "}
                                {moment(this.state.begin_date).format("L")} and{" "}
                                {moment(this.state.end_date).format("L")})</span>;
      case "2":
        return <span className="h4">Report</span>;
      default:
        return <span className="h4">Report</span>;
    }
  }

  render() {
    return (
      <span>
        <Container>
                  <Form onSubmit={this.handleCalculate}>
                    <Row form>
                      <Col
                        md={{ size: 4 }}
                        lg={{ size: 4 }}
                        xl={{ size: 3 }}
                        style={{ marginBottom: "1rem" }}
                      >
                        <FormGroup>
                          <Label for="beginDateInput">Sampling Begin Date</Label>
                          <br />
                          <SingleDatePicker
                            date={this.state.begin_date}
                            onDateChange={(begin_date) =>
                              this.setState({ begin_date: begin_date, data: {} })
                            }
                            focused={this.state.begin_dateFocused}
                            onFocusChange={({ focused }) =>
                              this.setState({ begin_dateFocused: focused })
                            }
                            isOutsideRange={(day) => false}
                            renderMonthElement={renderMonthElement}
                            numberOfMonths={1}
                            id="beginDateInput"
                            block={true}
                          />
                        </FormGroup>
                      </Col>
                      <Col
                        md={{ size: 4 }}
                        lg={{ size: 4 }}
                        xl={{ size: 3 }}
                        style={{ marginBottom: "1rem" }}
                      >
                        <FormGroup>
                          <Label for="endDateInput">Sampling End Date</Label>
                          <br />
                          <SingleDatePicker
                            date={this.state.end_date}
                            onDateChange={(end_date) =>
                              this.setState({ end_date: end_date, data: {} })
                            }
                            focused={this.state.end_dateFocused}
                            onFocusChange={({ focused }) =>
                              this.setState({ end_dateFocused: focused })
                            }
                            isOutsideRange={(day) => false}
                            renderMonthElement={renderMonthElement}
                            numberOfMonths={1}
                            id="endDateInput"
                            block={true}
                          />
                        </FormGroup>
                      </Col>
                      <Col
                        md={{ size: 4 }}
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <Button type="submit" color="primary">
                          Calculate
                        </Button>
                      </Col>
                    </Row>
                    <br />
                  </Form>
        </Container>
        {this.state.data && (
          <Container style={{ textAlign: "center" }}>
            <Row>
              <Col>
                {this.getTitle()}{" "}
                {this.state.data.length > 0 && (
                  <CSVLink
                    data={this.state.data}
                    filename={"Report Data.csv"}
                    target="_blank"
                  >
                    <i className="fas fa-file-csv"
                      alt="Download as CSV"
                      role="img"
                      aria-label="CSV file"
                      style={{ cursor: "pointer", fontSize: '1.75rem', color: '#1d6f42' }}></i>{' '}
                  </CSVLink>
                )}
                <br />
                <br />
                <span className="login-spinner">
                  <BounceLoader
                    size={60}
                    sizeUnit={"px"}
                    color={"#36D7B7"}
                    css={override}
                    loading={this.state.loading}
                  />
                </span>
                {this.state.error !== "" && (
                  <Alert
                    color="warning"
                    isOpen={this.state.showErrorAlert}
                    toggle={this.toggleErrorAlert}
                  >
                    {this.state.error}
                  </Alert>
                )}
                {this.state.message !== "" && (
                  <Alert
                    color="info"
                    isOpen={this.state.showMessageAlert}
                    toggle={this.toggleMessageAlert}
                  >
                    {this.state.message}
                  </Alert>
                )}
                {this.state.data.length > 0 && (
                    <Col>
                      <span>
                        <ReactTable
                          data={this.state.data}
                          columns={this.getColumns()}
                          // showPagination={false}
                          minRows={1}
                          className="-striped -highlight"
                        />
                      </span>
                    </Col>
                  )}
              </Col>
            </Row>
          </Container>
        )}
      </span>
    );
  }
}

const returnYears = () => {
  let years = [];
  for (let i = moment().year() - 15; i <= moment().year() + 1; i++) {
    years.push(
      <option key={i} value={i}>
        {i}
      </option>
    );
  }
  return years;
};

const renderMonthElement = ({ month, onMonthSelect, onYearSelect }) => (
  <div style={{ display: "flex", justifyContent: "center" }}>
    <div>
      <Input
        bsSize="sm"
        type="select"
        value={month.month()}
        onChange={(e) => onMonthSelect(month, e.target.value)}
      >
        {moment.months().map((label, value) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </Input>
    </div>
    <div>
      <Input
        bsSize="sm"
        type="select"
        value={month.year()}
        onChange={(e) => onYearSelect(month, e.target.value)}
      >
        {returnYears()}
      </Input>
    </div>
  </div>
);

export default DateRangeReports;
